<template>
    <div class="board">
        <div class="content">
            <div class="gadget-search-box">
                <b-icon icon="search"></b-icon>
                <input type="text" placeholder="ทะเบียนรถ / ชื่อลูกค้า / ยี่ห้อรถ" v-model="formFilter.keyword" @keyup.enter="submitFilter()" />
                <button class="btn btn-main" @click="submitFilter()">ค้นหา</button>
            </div>
        </div>
    </div>
</template>

<script>
import ModelKeywordFilter from '@/resources/models/KeywordFilter';

export default {
    data() {
        return {
            formFilter: ModelKeywordFilter.data()
        }
    },
    methods: {
        submitFilter() {
            this.$emit('lookup', this.formFilter);
        }
    }
}
</script>